// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'headset';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.333 13.533h-.566A2.267 2.267 0 0 1 .5 11.267V9a2.267 2.267 0 0 1 2.267-2.267h.566A.567.567 0 0 1 3.9 7.3v5.667a.567.567 0 0 1-.567.566zm11.9 0h-.566a.567.567 0 0 1-.567-.566V7.3a.567.567 0 0 1 .567-.567h.566A2.267 2.267 0 0 1 17.5 9v2.267a2.267 2.267 0 0 1-2.267 2.266zm-12.466-6.8a6.233 6.233 0 0 1 12.466 0m-3.966 9.634h1.7a2.267 2.267 0 0 0 2.266-2.267v-.567' />
    <path d='M10.133 17.5H9a1.133 1.133 0 1 1 0-2.267h1.133a1.134 1.134 0 0 1 0 2.267z' />
  </g>
);

export const viewBox = '0 0 18 18';
